"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOutputsForBeefyWithdraw = exports.calculateOutputsForBeefyDeposit = void 0;
const api_1 = require("../../../api");
const calculateOutputsForBeefyDeposit = (stepInitialBalance, vault) => {
    const { depositERC20Decimals, vaultRate, depositFeeBasisPoints } = vault;
    const depositFeeAmount = (stepInitialBalance * depositFeeBasisPoints) / 10000n;
    const depositAmountAfterFee = stepInitialBalance - depositFeeAmount;
    const depositERC20DecimalsAdjustment = 10n ** BigInt(depositERC20Decimals);
    const vaultERC20DecimalsAdjustment = 10n ** BigInt(api_1.BEEFY_VAULT_ERC20_DECIMALS);
    const decimalQuotient = vaultERC20DecimalsAdjustment / depositERC20DecimalsAdjustment;
    const receivedVaultTokenAmount = (depositAmountAfterFee * vaultERC20DecimalsAdjustment * decimalQuotient) /
        vaultRate;
    return {
        depositFeeAmount,
        depositAmountAfterFee,
        receivedVaultTokenAmount,
    };
};
exports.calculateOutputsForBeefyDeposit = calculateOutputsForBeefyDeposit;
const calculateOutputsForBeefyWithdraw = (stepInitialBalance, vault) => {
    const { depositERC20Decimals, vaultRate, withdrawFeeBasisPoints } = vault;
    const depositERC20DecimalsAdjustment = 10n ** BigInt(depositERC20Decimals);
    const vaultERC20DecimalsAdjustment = 10n ** BigInt(api_1.BEEFY_VAULT_ERC20_DECIMALS);
    const decimalQuotient = vaultERC20DecimalsAdjustment / depositERC20DecimalsAdjustment;
    const receivedWithdrawAmount = (stepInitialBalance * vaultRate) /
        decimalQuotient /
        vaultERC20DecimalsAdjustment;
    const withdrawFeeAmount = (receivedWithdrawAmount * withdrawFeeBasisPoints) / 10000n;
    const withdrawAmountAfterFee = receivedWithdrawAmount - withdrawFeeAmount;
    return {
        receivedWithdrawAmount,
        withdrawFeeAmount,
        withdrawAmountAfterFee,
    };
};
exports.calculateOutputsForBeefyWithdraw = calculateOutputsForBeefyWithdraw;
